// ============================================================================
// src/app/data/broilerFormDefaults.ts — the empty broiler batch form.
// ============================================================================
// Pure data. The blank-slate shape BatchesProvider seeds `form` with and the
// broiler batch editor resets to. Extracted from src/main.jsx in B2.1
// unchanged.
// ============================================================================

export const EMPTY_FORM = {
  name: '',
  breed: 'CC',
  hatchery: 'Meyer Hatchery',
  hatchDate: '',
  birdCount: 750,
  birdCountActual: '',
  brooder: '1',
  schooner: '2&3',
  processingDate: '',
  status: 'planned',
  notes: '',
  // Podio fields
  brooderIn: '',
  brooderOut: '',
  brooderFeedLbs: 0,
  schoonerFeedLbs: 0,
  gritLbs: 0,
  mortalityCumulative: 0,
  week4Lbs: 0,
  week6Lbs: 0,
  perLbStandardCost: 0,
  perLbStarterCost: 0,
  perLbGritCost: 0,
  chickCost: 0,
  totalToProcessor: 0,
  processingCost: 0,
  avgBreastLbs: 0,
  avgThighsLbs: 0,
  avgDressedLbs: 0,
  totalLbsWhole: 0,
  totalLbsCuts: 0,
  documents: [],
};
